import {
	__experimentalSpacer as Spacer,
	__experimentalHStack as HStack,
	__experimentalVStack as VStack,
	CheckboxControl,
	TimePicker,
} from '@wordpress/components';
import { Fragment, useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { ModalPromo } from '../../../admin/components/modal-promo.js';

export function Scheduler( props ) {
	const { rule, onChange } = props;
	const [ promo, showPromo ] = useState( false );

	const daysOfWeek = [
		'Sunday',
		'Monday',
		'Tuesday',
		'Wednesday',
		'Thursday',
		'Friday',
		'Saturday',
	];

	const defaultStartTime = { hours: '00', minutes: '00' };
	const defaultEndTime = { hours: '23', minutes: '59' };

	const setDayOfWeek = ( day, startTime, endTime ) => {
		onChange(
			'days',
			{
				...rule.days,
				[ day ]: {
					startTime: startTime ?? { ...defaultStartTime, startTime },
					endTime: endTime ?? { ...defaultEndTime, endTime },
				},
			},
			0
		);
	};

	const removeDayOfWeek = ( day ) => {
		const newObj = { ...rule.days };
		delete newObj[ day ];
		onChange( 'days', newObj, 0 );
	};

	return (
		<Fragment>
			<p>
				{ __(
					'To have more control on when popup is displayed you can use the following options.'
				) }
			</p>
			<h2>{ __( 'Time', 'popper' ) }</h2>
			<p>
				{ __(
					'Popup are displayed all day long. If you want limit the hour of day it will be shown, check the field below.',
					'popper'
				) }
			</p>
			<CheckboxControl
				label={ __( 'Custom time', 'popper' ) }
				checked={ rule.customTime || false }
				onChange={ ( val ) =>
					! popper.pro
						? showPromo( true )
						: onChange( 'customTime', val, 0 )
				}
				id="popper-custom-time"
				__nextHasNoMarginBottom
			/>
			{ rule.customTime && (
				<Spacer marginTop="5">
					<HStack spacing="1" justify="flex-start" alignment="top">
						<TimePicker.TimeInput
							label={ __( 'Start time', 'popper' ) }
							value={ rule.startTime }
							onChange={ ( val ) =>
								onChange( 'startTime', val, 0 )
							}
							__nextHasNoMarginBottom
						/>
						<TimePicker.TimeInput
							label={ __( 'End time', 'popper' ) }
							value={ rule.endTime }
							onChange={ ( val ) =>
								onChange( 'endTime', val, 0 )
							}
							__nextHasNoMarginBottom
						/>
					</HStack>
				</Spacer>
			) }
			<h2>{ __( 'Days of week', 'popper' ) }</h2>
			<p>
				{ __(
					'Popup are displayed every day. If you want limit the day of the week it will be shown, check the fields below.',
					'popper'
				) }
			</p>
			<VStack>
				{ daysOfWeek.map( ( d ) => {
					return (
						<Fragment key={ d }>
							<CheckboxControl
								label={ d }
								checked={ rule.days?.[ d ] }
								onChange={ ( val ) => {
									if ( val ) {
										! popper.pro
											? showPromo( true )
											: setDayOfWeek( d );
									} else {
										removeDayOfWeek( d );
									}
								} }
								id={ `popper-${ d }` }
								__nextHasNoMarginBottom
							/>
							{ rule.days?.[ d ] && (
								<Spacer marginTop="2">
									<HStack
										spacing="1"
										justify="flex-start"
										alignment="top"
									>
										<TimePicker.TimeInput
											label={ __(
												'Start time',
												'popper'
											) }
											value={ rule.days[ d ].startTime }
											onChange={ ( val ) =>
												setDayOfWeek( d, val, null )
											}
										/>
										<TimePicker.TimeInput
											label={ __( 'End time', 'popper' ) }
											value={ rule.days[ d ].endTime }
											onChange={ ( val ) =>
												setDayOfWeek( d, null, val )
											}
										/>
									</HStack>
								</Spacer>
							) }
						</Fragment>
					);
				} ) }
			</VStack>
			{ promo && (
				<ModalPromo onRequestClose={ () => showPromo( false ) } />
			) }
		</Fragment>
	);
}
